import { Calendar, MapPin, ArrowRight } from "lucide-react";

export default function EventCard({ title, date, location, image }) {
    return (
        <div className="
            bg-white rounded-xl border border-gray-100 shadow-sm 
            hover:shadow-md transition-all duration-300 overflow-hidden
            w-full
        ">
            {image && (
                <div className="relative h-48 overflow-hidden">
                    <img 
                        src={image} 
                        alt={title} 
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
                </div>
            )}
            
            <div className="p-5">
                {/* Data em destaque */}
                <div className="flex items-center gap-2 mb-3">
                    <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center">
                        <Calendar className="w-4 h-4 text-emerald-500" />
                    </div>
                    <span className="text-sm font-medium text-gray-700">
                        {date}
                    </span>
                </div>

                {/* Título */}
                <h2 className="text-lg font-medium text-gray-800 mb-2 line-clamp-2">
                    {title}
                </h2>

                {/* Localização */}
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                    <MapPin className="w-4 h-4 text-gray-400" />
                    <span className="line-clamp-1">{location}</span>
                </div>

                {/* Botão */}
                <button className="
                    w-full inline-flex items-center justify-center gap-2
                    bg-emerald-600 hover:bg-emerald-700 
                    text-white font-medium text-sm
                    py-2.5 rounded-lg
                    transition-colors duration-200 shadow-sm
                ">
                    Ver Detalhes
                    <ArrowRight className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}